var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"bigBanner",attrs:{"src":_vm.bgUrl}}),_c('Product'),_c('Case'),_c('yxt-info',{staticClass:"wow slideInUp",attrs:{"id":"yxtInfo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }